/** Until auth provides real PM user id */
export const PM_PLACEHOLDER_ID = 'pm-local';

/** Earliest calendar day PM may approve/reject (aligned with employee fill cutoff). */
export const TIMESHEET_FILL_MIN_DATE_STR = '2026-05-08';

/** Earliest week (Monday) PM may approve/reject; weeks starting before this are blocked. */
export const PM_APPROVAL_WEEK_MIN_MONDAY_STR = '2026-04-27';
